/**
 * Shared UI component for UI Form Action Footer.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { UiButtonComponent } from '../ui-button/ui-button.component';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-form-action-footer',
  standalone: true,
  imports: [UiButtonComponent, UiLabelTranslatePipe],
  templateUrl: './ui-form-action-footer.component.html',
  styleUrl: './ui-form-action-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFormActionFooterComponent {
  readonly showBack = input(false);
  readonly showSave = input(true);
  readonly showNext = input(false);
  readonly isSaving = input(false);
  readonly disableBack = input(false);
  readonly disableSave = input(false);
  readonly disableNext = input(false);
  readonly backLabel = input('Back');
  readonly saveLabel = input('Save');
  readonly nextLabel = input('Next');
  readonly backClicked = output<void>();
  readonly saveClicked = output<void>();
  readonly nextClicked = output<void>();
  readonly usesSplitLayout = computed(() => this.showBack() && this.showSave() && this.showNext());

  onBackClicked(): void {
    this.backClicked.emit();
  }

  onSaveClicked(): void {
    this.saveClicked.emit();
  }

  onNextClicked(): void {
    this.nextClicked.emit();
  }
}
